import DelayModal from './main.delay'

export default DelayModal